import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetParticipationSelectedOptionsRequestSchema = z
  .object({
    campaignId: z.union([z.number(), z.string()]),
    participationId: z.union([z.number(), z.string()]),
  })
  .describe('GetParticipationSelectedOptionsRequestSchema');

export type GetParticipationSelectedOptionsRequest = z.infer<
  typeof GetParticipationSelectedOptionsRequestSchema
>;

const ResolvedOptionResponseSchema = z
  .object({
    optionName: z.string(),
    valueName: z.string(),
  })
  .describe('ResolvedOptionResponseSchema');

export type ResolvedOptionResponse = z.infer<typeof ResolvedOptionResponseSchema>;

const SelectedOptionItemResponseSchema = z
  .object({
    goodsNo: z.number(),
    goodsName: z.string(),
    imageUrl: z.string(),
    soldOut: z.boolean().nullable().optional(),
    options: z.array(ResolvedOptionResponseSchema),
    extraOptions: z.array(ResolvedOptionResponseSchema),
  })
  .describe('SelectedOptionItemResponseSchema');

export type SelectedOptionItemResponse = z.infer<typeof SelectedOptionItemResponseSchema>;

const GetParticipationSelectedOptionsResponseDataSchema = z
  .object({
    totalCount: z.number(),
    items: z.array(SelectedOptionItemResponseSchema),
  })
  .describe('GetParticipationSelectedOptionsResponseDataSchema');

export type GetParticipationSelectedOptionsResponseData = z.infer<
  typeof GetParticipationSelectedOptionsResponseDataSchema
>;

const GetParticipationSelectedOptionsResponseSchema = createApiResponseSchema(
  GetParticipationSelectedOptionsResponseDataSchema,
);

export type GetParticipationSelectedOptionsResponse = z.infer<
  typeof GetParticipationSelectedOptionsResponseSchema
>;

export const getParticipationSelectedOptions = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetParticipationSelectedOptionsRequestSchema),
    async ({ campaignId, participationId }: GetParticipationSelectedOptionsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetParticipationSelectedOptionsResponse>(
          partnerApiPath.getParticipationSelectedOptions(campaignId, participationId),
        ),
      ),
    validateApiResponse(GetParticipationSelectedOptionsResponseSchema),
  ),
);
